import LTR from "@brand-icons/global/package-arrow/package-arrow-ltr.svg";
import RTL from "@brand-icons/global/package-arrow/package-arrow-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PackageArrowIcon = iconFactory("PackageArrowIcon", LTR, RTL);
